export default {
  setInvoices(state, value) {
    state.invoices = value
  },
  updateInvoices(state, value) {
    state.invoices = state.invoices.concat(value)
  },
  prependInvoices(state, value) {
    state.invoices.unshift(value)
  },
  setInvoice(state, value) {
    state.invoice = value
  },
  setInvoiceField(state, obj) {
    if (state.invoice) {
      state.invoice = { ...state.invoice, ...obj }
    }
  },
  changeInvoice(state, obj) {
    for (let i = 0; i < state.invoices.length; i++) {
      if (state.invoices[i].id === obj.id) {
        const item = _.cloneDeep(obj)
        state.invoices.splice(i, 1, item)
        break
      }
    }
  },
  deleteInvoice(state, id) {
    for (let i = 0; i < state.invoices.length; i++) {
      if (state.invoices[i].id === id) {
        state.invoices.splice(i, 1)
        break
      }
    }
  },
  changeInvoiceItem(state, obj) {
    if (state.invoice.items) {
      for (let i = 0; i < state.invoice.items.length; i++) {
        if (state.invoice.items[i].id === obj.id) {
          const item = _.cloneDeep(obj)
          state.invoice.items.splice(i, 1, item)
          break
        }
      }
    }
  },
  setInvoiceFilters(state, payload) {
    state.invoiceFilters = payload
  },
  setInvoiceStatuses(state, value) {
    state.invoiceStatuses = value
  },
}
